import { render, staticRenderFns } from "./cpiOperatorPhoneListTab.vue?vue&type=template&id=398c2085&lang=pug"
import script from "./cpiOperatorPhoneListTab.vue?vue&type=script&lang=js"
export * from "./cpiOperatorPhoneListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports